export default [{
    "courseId": 0,
    "hot":1,
    "picUrl": "https://www.superdental.com.cn/images/home1.jpg",
    "courseTitle": "玻璃陶瓷分类",
    "courseTime": "2022-11-08 12:11:11",
    "courseSubTitle": "",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201228/5fe9873a6cdb9.png\"></div>"
  },
  {
    "courseId": 1,
    "hot":0,
    "picUrl": "https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/files/e064d7b87c33e9c8768b3922c412b5d.png",
    "courseTitle": "义获嘉 A-D 20色与 3D Maseter 转换表",
    "courseTime": "2022-10-28 16:21:36",
    "courseSubTitle": "",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201228/5fe98712d0677.png\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201228/5fe9871a00a7c.png\" alt=\"\"></div>"
  }, {
    "courseId": 2,
    "hot":0,
    "picUrl": "https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/files/870462e8d31bfa82189ff2516bef736.png",
    "courseTitle": "贴面案例",
    "courseTime": "2022-10-08 08:50:21",
    "courseSubTitle": "",
     "newsDetail":"<div style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201229/5fea79b8a9f90.jpg\" style=\"width: 1070px; height: 764px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201229/5fea79b94dc76.jpg\" style=\"width: 1070px; height: 764px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201229/5fea79b9d66b5.jpg\" style=\"width: 1070px; height: 764px;\"></div>"
  }
]



// WEBPACK FOOTER //
// ./src/assets/config/schoolList.js